export function AISection() {
  return (
    <div className="px-3 xs:px-4 sm:px-6 md:px-8 pt-8 xs:pt-10 sm:pt-12 md:pt-16 lg:pt-20 pb-1 xs:pb-2 sm:pb-3 lg:pb-4 bg-white mx-2 sm:mx-4 lg:mx-8">
      <div className="max-w-6xl mx-auto">
        <div className="bg-[#F5F8F9] rounded-xl p-8 xs:p-10 sm:p-12 md:p-16 lg:p-20 text-center">
          <h2 className="text-2xl xs:text-3xl sm:text-4xl md:text-5xl font-bold text-[#1D2125] mb-4 xs:mb-5 sm:mb-6">
            AI - when it helps
          </h2>
          <p className="text-sm xs:text-base sm:text-lg text-[#4D4F52] mb-6 xs:mb-7 sm:mb-8 max-w-xs xs:max-w-sm sm:max-w-2xl md:max-w-3xl lg:max-w-4xl mx-auto leading-relaxed px-2 xs:px-4 sm:px-0">
            Start with deterministic workflows that save time today: pending fee nudges, proof
            reviews, attendance summaries. Layer in AI assistance for reconciliation, reminders,
            and anomaly detection as your team is ready. Always opt-in. Always transparent.
          </p>
        </div>
      </div>
    </div>
  );
}

